import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Banner, Button, ErrorBanner, Field, Input } from '../components/ui';
import { AuthFrame } from './LoginPage';

export default function ForgotPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  return (
    <AuthFrame>
      <div className="stack tight">
        <span className="eyebrow">Circdal rep portal</span>
        <h1>Reset your password</h1>
      </div>
      {sent ? (
        <Banner tone="ok">If {email} has a portal account, a reset link is on its way. The link works for 2 hours.</Banner>
      ) : (
        <form
          className="stack"
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            setError(null);
            try {
              await api.post('/auth/password/forgot', { email });
              setSent(true);
            } catch (err) {
              setError(err);
            } finally {
              setBusy(false);
            }
          }}
        >
          <ErrorBanner error={error} />
          <Field label="Email" htmlFor="email">
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </Field>
          <Button type="submit" variant="primary" busy={busy}>
            Email me a reset link
          </Button>
        </form>
      )}
      <Link to="/login" className="small">
        Back to sign in
      </Link>
    </AuthFrame>
  );
}
